import SensorsTable from './SensorsTable';
import Content from '../dashboard/Content';

const UnknownSensors: React.FC = () => (
  <Content title="خانه / سنسورهای ناشناخته">
    <SensorsTable />
  </Content>
);

export default UnknownSensors;
